
<template>
  <!--编辑app功能-->
  <div>
    <x-tabula
      :dataSource="dataSource"
      rowKey="action_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_t" slot-scope="{row}">
        <img :style="{width: '30px', height: '30px'}" :src="row.icon_url" alt="">
      </template>
    </x-tabula>

    <!--添加功能的弹窗-->
    <a-modal
      title="添加功能"
      :visible="visible"
      @ok="isSubmit = true"
      @cancel="visible=false"
      :btnLoading="btnLoading.loading"
      v-bind="this.$store.state.modalConfig"
    >
      <x-simpleForm
        ref="addEdit"
        @updateIsSubmit="isSubmit=$event"
        @updateModalQuery="modalQuery=$event"
        :btnLoading="btnLoading"
        :modalQuery="modalQuery"
        :itemLayout="$store.state.modal_ItemLayout"
        :formList="formList"
        :formData="formData"
        :isSubmit="isSubmit"
        :transferVal="transferVal"
        :formKey="formKey"
        :addParam="addParam"
        :editParam="editParam"
        :detailParam="detailParam"
      >
      </x-simpleForm>
    </a-modal>
  </div>
</template>

<script>
import mixin from '../../js/mixins';
export default {
  mixins: [mixin.fetchSelect, mixin.addEdit],
  name: 'editAppFun',
  data () {
    let decoratorOptions = {
      title: {
        validateTrigger: 'blur',
        rules: [
          {required: true, message: '请输入应用名称'},
          {min: 2, max: 20, message: '功能名为2-20个字'}
        ]
      },
      unique_mark: {
        validateTrigger: 'blur',
        rules: [
          {required: true, message: '请输入功能识别符'},
          {min: 2, max: 20, message: '功能识别符为2-20个字'}
        ]
      },
      icon: {
        rules: [{required: true, message: '请上传图标'}]
      },
      platform: {
        rules: [{required: true, message: '请选择平台'}]
      },
      sort: {rules: []},
      is_default: {
        valuePropName: 'checked',
        initialValue: false,
        rules: [{required: true, message: '请选择是否默认'}]
      },
      price: {
        validateTrigger: 'blur',
        rules: [{required: true, message: '请输入价格'}]
      },
      scope_type: {
        rules: [{required: true, message: '请选择应用范围'}]
      },
      behavior_type: {
        rules: [{required: true, message: '请选择行为方式'}]
      },
      behavior_param: {},
      description: {rules: [{min: 2, max: 20, message: '描述信息为2-20个字'}]}
    };
    return {
      scopeType: '',
      scopeArr: [],
      transferVal: '',
      searchList: [],
      tableOptList: [
        { text: '添加功能', icon: 'plus', handle: this.handleOpenModal, key: 'addbtn' }
      ],
      rowOptList: [
        { text: '', customRender: true, handle: row => this.statusChange(row), key: 'status' },
        { text: '编辑', handle: row => this.toEditFun(row.action_id), key: 'edit' },
        { text: '删除', handle: row => this.$children[0].showDeleteConfirm(row), key: 'delete' }
      ],
      columns: [
        { title: '功能名称', dataIndex: 'title', align: 'left', width: '' },
        { title: '功能识别符', dataIndex: 'unique_mark', align: 'left', width: '' },
        { title: '功能图标', dataIndex: 'icon', align: 'left', width: '', scopedSlots: {customRender: 'action_t'} },
        { title: '排序', dataIndex: 'sort', align: 'left', width: '' },
        { title: '应用平台', dataIndex: 'platform', align: 'left', width: '' },
        { title: '默认功能', dataIndex: 'is_default', align: 'left', width: '' },
        { title: '状态', dataIndex: 'status_str', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        application_id: ''
      },
      listApi: {
        url: '/actions',
        resHandle: this.listResHandle,
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        title: ''
      },
      deleteParam: {
        batchDelMsg: '',
        delMsg: '功能',
        url: '/actions',
        param: {pk_key: 'action_id', pk_val: ''}
      },

      modalQuery: '',
      formData: '',
      isSubmit: false,
      visible: false,
      btnLoading: { loading: false },
      addParam: {
        url: `/actions`,
        reqHandle: this.addReqHandle,
        resHandle: this.addResHandle
      },
      editParam: {
        url: `/actions/`,
        resHandle: this.editResHandle
      },
      detailParam: {
        url: `/actions/`,
        resHandle: this.detailResHandle
      },
      formKey: {
        title: '',
        unique_mark: '',
        icon: '',
        platform: '',
        sort: '',
        is_default: '',
        price: '',
        scope_type: '',
        behavior_type: '',
        behavior_param: '',
        description: ''
      },
      formList: [
        {
          label: '功能名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入功能名称',
          props: ['title', decoratorOptions.title]
        },
        {
          label: '功能标识符',
          inputType: 'input',
          options: [],
          placeholder: '请输入功能标识符',
          props: ['unique_mark', decoratorOptions.unique_mark]
        },
        {
          label: '图标',
          inputType: 'upload',
          options: [],
          placeholder: '',
          name: 'icon',
          resUrl: 'icon_url',
          resName: 'file_name',
          fileList: [],
          uploadParam: {
            action: this.$store.state.uploadUrl,
            accept: this.$store.state.imgAccep,
            headers: {},
            listType: 'picture'
          },
          props: ['icon', decoratorOptions.icon]
        },
        {
          label: '平台',
          inputType: 'checkboxGroup',
          options: [],
          placeholder: '请选择平台',
          props: ['platform', decoratorOptions.platform]
        },
        {
          label: '排序',
          inputType: 'input',
          options: [],
          placeholder: '请输入排序',
          type: 'number',
          extra: '默认排序：99',
          props: ['sort', decoratorOptions.sort]
        },
        {
          label: '是否默认',
          inputType: 'switch',
          options: [],
          placeholder: '',
          props: ['is_default', decoratorOptions.is_default]
        },
        {
          label: '价格',
          inputType: 'input',
          options: [],
          placeholder: '请输入价格',
          props: ['price', decoratorOptions.price]
        },
        {
          label: '应用范围',
          inputType: 'select',
          options: this.$store.state.userRange,
          handle: this.handleUserRange,
          placeholder: '请选择应用范围',
          props: ['scope_type', decoratorOptions.scope_type]
        },
        {
          label: '选择城市',
          inputType: 'treeSelect',
          options: [],
          placeholder: '请选择城市',
          treeCheckable: true,
          key: 'city',
          props: ['city_scope', {
            rules: [{required: true, message: '请选择城市'}]
          }]
        },
        {
          label: '选择小区',
          inputType: 'transfer',
          options: [],
          placeholder: '',
          titles: ['小区列表', '已选'],
          key: 'community',
          props: ['community_scope', {
            rules: [{required: true, message: '请选择小区'}]
          }]
        },
        {
          label: '行为方式',
          inputType: 'select',
          options: [],
          placeholder: '请选择行为方式',
          props: ['behavior_type', decoratorOptions.behavior_type]
        },
        {
          label: '行为参数',
          inputType: 'input',
          options: [],
          placeholder: '请输入行为参数',
          props: ['behavior_param', decoratorOptions.behavior_param]
        },
        {
          label: '描述',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入描述',
          props: ['description', decoratorOptions.description]
        }
      ]
    };
  },
  created () {
    this.handleQuery();
  },
  methods: {
    handleQuery () {
      this.routeQuery = this.$route.query.id;
      this.searchParams.application_id = this.routeQuery;
      let scopeArr = this.getLocal('scopeArray');
      if (scopeArr && scopeArr.length) {
        this.scopeArr = scopeArr;
      }

      let platform = [];
      let query = this.$route.query;
      for (let item in query) {
        if (item === 'android' || item === 'ios') {
          if (query[item] !== '0') {
            let platformObj = { android: 1, ios: 2 }; // Android: 1 iOS: 2
            platform.push({
              label: item,
              value: platformObj[item]
            });
          }
        }
      }
      let range = [];
      this.scopeType = parseInt(query.scope_type);
      if (this.scopeType > 0) {
        this.$store.state.userRange.forEach((el) => {
          if (parseInt(this.scopeType) === el.value) {
            range.push({...el});
          }
        });
      }

      this.formList.forEach((el) => {
        let prop = el.props;
        if (prop && prop[0] === 'scope_type' && this.scopeType > 0) {
          el.options = range; // 根据app应该范围，限制功能范围的下拉列表
        }
        if (prop && prop[0] === 'platform') {
          el.options = platform;
        }
      });
    },
    detailResHandle (res) {
      let values = {};
      for (let item in res) {
        if (this.formKey.hasOwnProperty(item)) {
          values[item] = res[item];
        }
      }
      res.is_default === 1 ? values.is_default = true : values.is_default = false;
      let arr = [];
      res.android && arr.push(1); // Android: 1 iOS: 2
      res.ios && arr.push(2);
      values.platform = arr;
      if (res.scope) {
        values.scope = res.scope.split(',');
        this.rangeResVal(values, res);
      }
      this.handleUserRange(res.scope_type, values);
    },
    editResHandle (res) {
      this.visible = false;
      this.$children[0].getTableList();
    },
    /* 提交表单前处理数据 */
    addReqHandle (param) {
      param.application_id = this.routeQuery;
      param.is_default = param.is_default === true ? 1 : 0;
      let platform = param.platform;
      if (platform.length) { // Android: 1 iOS: 2
        platform.forEach((el) => {
          el === 1 && (param.android = 1);
          el === 2 && (param.ios = 1);
        });
        if (!param.hasOwnProperty('ios')) {
          param.ios = 0;
        }
        if (!param.hasOwnProperty('android')) {
          param.android = 0;
        }
      } else {
        param.android = 0;
        param.ios = 0;
      }
      param = this.rangeReqVal(param);
      return param;
    },
    addResHandle (res) {
      this.visible = false;
      this.$children[0].getTableList();
    },
    /* 进入编辑功能 */
    toEditFun (id) {
      this.handleOpenModal();
      this.$nextTick(() => {
        this.modalQuery = id;
      });
    },
    /* 初始化弹窗 */
    handleOpenModal () {
      this.visible = true;
      this.$nextTick(() => {
        !this.modalQuery && this.handleUserRange(this.scopeType, { scope_type: this.scopeType });
      });

      this.formList.forEach((el, index) => {
        if (el.inputType && el.inputType === 'upload') {
          el.fileList = [];
        }
        let prop = el.props;
        if (prop && prop[0] === 'behavior_type') {
          this.typeSelect({ index: index, query: 'app_behavior_type_desc' });
        }
      });
    },
    /* 状态切换 */
    statusChange (row) {
      this.$put({
        url: `/actions/${row.action_id}`,
        params: { status: row.status === 1 ? 0 : 1 }
      }).then((res) => {
        this.$message.success('切换成功！');
        this.$children.forEach((el) => {
          if (el.hasOwnProperty('getTableList')) {
            el.getTableList();
          }
        });
      });
    },
    /* 处理用户范围 */
    handleUserRange (val, formVals) {
      let userTypeObj = {
        0: { city: false, community: false },
        1: { city: true, community: false },
        2: { city: false, community: true }
      };
      this.handleDynamicForm(val, userTypeObj);

      if (val > 0 && this.scopeArr.length) {
        if (val === 1) { // 城市
          this.formList[8].options = this.scopeArr;
        } else { // 小区
          let arr = [];
          this.scopeArr.forEach((el) => {
            arr.push({key: `${el.value}`, title: el.label});
          });
          this.formList[9].options = arr;
        }
      } else {
        console.log('val: ', val);
        if (val === 1) { // 城市
          this.regionSelect((data) => {
            this.formList[8].options = data;
          }, 'formLst', '1,2');
        } else if (val === 2) { // 小区
          this.communitySelect((data) => {
            let arr = [];
            data.forEach((el) => {
              arr.push({key: `${el.value}`, title: el.label});
            });
            this.formList[9].options = arr;
          });
        }
      }

      if (formVals) {
        this.$nextTick(() => {
          this.$refs.addEdit.form.setFieldsValue(formVals);
          if (formVals.scope_type === 2) {
            this.transferVal = formVals.scope;
          }
        });
      }
    },
    listResHandle (res) {
      res.forEach((el, index) => {
        let arr = [];
        el.android && arr.push('Android');
        el.ios && arr.push('iOS');
        el.platform = arr.join(' | ');
        el.is_default = el.is_default === 1 ? '是' : '否';
      });
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/package/pageCompo/editAppFun.vue